import { createRoute } from "@tanstack/react-router";

import { root } from "routes";

import Layout from "theme/ui/Layout";
import Users from "areas/users/pages/Users";
import type { UsersFilters } from "./models";


const _root = createRoute({
	getParentRoute: () => root,
	id: "users-layout",
	component: () => <Layout.Light />
});

const index = createRoute({
	getParentRoute: () => _root,
	path: "users",
	component: () => <Users />,
	staticData: {
		footer: true
	},
	validateSearch: () => ({}) as UsersFilters
});


const partners = _root.addChildren([index]);
export default partners;